var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateSignUpBenefits3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.742,
    height: 44.499,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4716",
    x: 0,
    y: 0,
    width: 43.742,
    height: 44.499,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24418",
    "data-name": "Group 24418",
    transform: "translate(-73.531 -611)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 73.53, 611)",
    filter: "url(#Rectangle_4716)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4716-2",
    "data-name": "Rectangle 4716",
    width: 25.742,
    height: 26.499,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#040227"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24408",
    "data-name": "Group 24408",
    transform: "translate(86.695 622.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24413",
    "data-name": "Group 24413",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46378",
    "data-name": "Path 46378",
    d: "M12.329,91.382H.985a.966.966,0,0,1-.962-.962v-9.13a.963.963,0,0,1,.962-.962H15.356a.963.963,0,0,1,.962.962v5.439a.206.206,0,1,1-.413,0V81.289a.549.549,0,0,0-.549-.549H.985a.549.549,0,0,0-.549.549v9.13a.549.549,0,0,0,.549.549H12.329a.206.206,0,1,1,0,.413Z",
    transform: "translate(-0.022 -77.412)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46379",
    "data-name": "Path 46379",
    d: "M265.2,179.836a.207.207,0,0,1-.045-.409l6.269-1.383a.207.207,0,1,1,.091.4l-6.269,1.383C265.225,179.832,265.209,179.836,265.2,179.836Z",
    transform: "translate(-255.371 -171.577)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46380",
    "data-name": "Path 46380",
    d: "M6.476,179.836a.169.169,0,0,1-.045,0L.162,178.449a.207.207,0,1,1,.091-.4l6.269,1.383a.207.207,0,0,1-.045.409Z",
    transform: "translate(0 -171.577)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46381",
    "data-name": "Path 46381",
    d: "M176.05,200.68h-2.862a.451.451,0,0,1-.45-.45v-.669a.451.451,0,0,1,.45-.45h2.862a.451.451,0,0,1,.45.45v.669a.451.451,0,0,1-.45.45m-2.862-1.156a.037.037,0,0,0-.037.037v.669a.037.037,0,0,0,.037.037h2.862a.037.037,0,0,0,.037-.037v-.673a.037.037,0,0,0-.037-.037Z",
    transform: "translate(-166.468 -191.884)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46382",
    "data-name": "Path 46382",
    d: "M205.1,233.191a.73.73,0,0,1-.731-.731v-1.284a.206.206,0,0,1,.413,0v1.284a.318.318,0,1,0,.636,0v-1.284a.206.206,0,0,1,.413,0v1.284a.73.73,0,0,1-.731.731",
    transform: "translate(-196.95 -222.586)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46383",
    "data-name": "Path 46383",
    d: "M135.986,3.328a.2.2,0,0,1-.206-.206V1.057a.645.645,0,0,0-.644-.644h-4.8a.645.645,0,0,0-.644.644V3.122a.206.206,0,1,1-.413,0V1.057A1.059,1.059,0,0,1,130.332,0h4.8a1.059,1.059,0,0,1,1.057,1.057V3.122a.21.21,0,0,1-.206.206",
    transform: "translate(-124.583)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46384",
    "data-name": "Path 46384",
    d: "M163.522,31.947a.2.2,0,0,1-.206-.206V30.109h-3.931V31.74a.206.206,0,1,1-.413,0V29.9a.2.2,0,0,1,.206-.206h4.344a.2.2,0,0,1,.206.206V31.74a.207.207,0,0,1-.206.206",
    transform: "translate(-153.201 -28.618)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46385",
    "data-name": "Path 46385",
    d: "M325.926,246.35a.245.245,0,0,1-.095-.021l-.64-.326a4.561,4.561,0,0,1-2.494-4.08V240a.211.211,0,0,1,.132-.194l3.023-1.173a.186.186,0,0,1,.149,0l3.023,1.173a.211.211,0,0,1,.132.194v1.92a4.561,4.561,0,0,1-2.494,4.08l-.64.326A.246.246,0,0,1,325.926,246.35Zm-2.812-6.207v1.776a4.157,4.157,0,0,0,2.271,3.713l.545.281.545-.281a4.157,4.157,0,0,0,2.271-3.713v-1.776l-2.816-1.094Z",
    transform: "translate(-310.985 -229.96)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46387",
    "data-name": "Path 46387",
    d: "M378.2,319.823a.194.194,0,0,1-.145-.062l-.57-.57a.207.207,0,0,1,.293-.293l.425.425,1.367-1.367a.207.207,0,1,1,.293.293l-1.52,1.516A.222.222,0,0,1,378.2,319.823Z",
    transform: "translate(-363.725 -306.357)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSignUpBenefits3);
export default __webpack_public_path__ + "static/media/candidate-sign-up-benefits-3.11564769e27260eed97859771bbc4f91.svg";
export { ForwardRef as ReactComponent };